<template>
  <div>
    <div class="blog-header">
      <div class="blog-header__left">
        <div class="blog-header__date">
          <slot name="date" />
        </div>
        <div class="blog-header__author">
          <slot name="author" />
        </div>
        <div class="blog-header__tags">
          <slot name="tags" />
        </div>
      </div>
      <div class="blog-header__right">
        <slot name="social" />
      </div>
    </div>
    <div class="blog-subheader">
      <div class="blog-subheader__tags-mobile">
        <slot name="tags" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlogHeader'
};
</script>

<style lang="scss" src="@/assets/components/blog/blog-header-view.scss"></style>



// WEBPACK FOOTER //
// blog-detail-header.vue